// extracted by mini-css-extract-plugin
export var breadcrumb = "_12-3";
export var breadcrumbArrow = "_12-4";
export var breadcrumbs = "_12-0";
export var link = "_12-5";
export var sm = "_12-1";
export var xs = "_12-2";